class FileManager {
  constructor() {
    console.log('LSFileManager constructor');
    this.baseUrl = '';
    this.lsFileName = 'lightstreamer';
    this.sportsSDKFileName = 'spnsportssdk';
    this.extractBaseUrl();
  }

  extractBaseUrl() {
    var curScriptName = 'spnsportssdk.js';
    var scripts = document.getElementsByTagName('script');
    var surl = '';
    for (var si = 0; si < scripts.length; si++) {
      if (scripts[si].src && scripts[si].src.indexOf(curScriptName) > 0) {
        surl = scripts[si].src;
      }
    }
    this.baseUrl = surl.substr(0, surl.indexOf(curScriptName)) || '/';
    // this.baseUrl = "http://localhost:8081/";
  }

  createLSFileUrl() {
    let lsFileName = this.lsFileName;
    let lsDebugMode = localStorage.getItem('LS_DEBUG_MODE');
    if (lsDebugMode == true) {
      lsFileName = lsFileName + '-debug';
    }
    let baseUrl = this.baseUrl;
    let lsFullUrl = baseUrl + 'lib/' + lsFileName + '.js';
    return lsFullUrl;
  }

  loadLightStreamerSDK(lsFullUrl, callback, errorCallback) {
    let lsScript = document.createElement('script');
    lsScript.src = lsFullUrl;
    lsScript.addEventListener('load', callback);
    lsScript.addEventListener('error', errorCallback);
    document.head.appendChild(lsScript);
  }
  createSDKCSSUrl() {
    let cssBaseUrl = this.baseUrl;
    let fullCssUrl = cssBaseUrl + this.sportsSDKFileName + '.css';
    return fullCssUrl;
  }

  loadSportsSDKCss(cssFullUrl, callback) {
    if(this.baseUrl !== "/"){
      let link = document.createElement('link');
      link.href = cssFullUrl;
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.addEventListener('load', callback);
      document.head.appendChild(link);
    } else {
      setTimeout(() => callback() , 2000);
    }
  }

  executeCallbacks() {
    for (let counter = 0; counter < window.sportsSDKLoadCallback?.length; counter++) {
      if (typeof window.sportsSDKLoadCallback[counter] === 'function') {
        window.sportsSDKLoadCallback[counter]();
      }
    }
  }
}

let fileManager = new FileManager();
let cssFullUrl = fileManager.createSDKCSSUrl();
console.info('cssFullUrl', cssFullUrl);
  fileManager.loadSportsSDKCss(cssFullUrl, () => {
    console.log('SDK CSS Loaded');
    fileManager.executeCallbacks();
  });

export default FileManager;
